function SignInCallToAction(props) {
  const { REACT_APP_SIGNINURL } = process.env;
  const { totalCommentsLength, appType } = props;
  const windowLocationString = `${window.location}`;
  const url = windowLocationString.endsWith('/') ? windowLocationString.slice(0, -1) : windowLocationString;

  return (
    <>
      <p className="ugc-comments-list__sign-in-cta">
        There are {totalCommentsLength ?? 0}{" "}
        comments.&nbsp;
        <span>
          <a
            id="signInLink"
            rel="nofollow"
            href={`${REACT_APP_SIGNINURL}/?u=&referrer=${url}${appType && appType === 'mapview' ? '#ugc-mapview' : ''}`}
            aria-label="Sign in to add your comment"
            data-component="ugcGoToLoginLink">
            Sign in to add yours.
          </a>
        </span>
      </p>
    </>
  );
}

export default SignInCallToAction;
